<template>
	<div>
        <div v-if="!isShowEmail">
              <b-form-select v-model="selectedProfile" @change="onChangeProfile" class="fontsize16 profile-dropdown" :disabled="isProfileDisabled">
                    <b-form-select-option value="" disabled>Please Select Profile</b-form-select-option>
                    <option :value="prosp" :key="prosp.id" v-for="prosp in filteredProspectsForProfiles" >{{prosp.Name}}</option>
                </b-form-select>
            <h6 class="pl-3 pr-3 w-100 fontsize14">Date: {{prioritySubmittedDate}}</h6>
            <h6 class="pl-3 pr-3 w-100 fontsize14"><i>Priority: {{priorityData.CciMap.Priority}}</i></h6>
            <h6 class="pl-3 pr-3 w-100 fontsize14"><a target="blank" class="text-decoration-underline"  :href="snapshotDetails.Url">{{priorityData.CciMap.SnapshotName}}</a></h6>
            <h6 class="pl-3 pr-3 w-100 fontsize14" v-if="priorityData.CciMap.hasOwnProperty('Scorecard')"><a id="copyPDFURLID" target="blank" :href="priorityData.CciMap.Scorecard">Hiring Scorecard</a></h6>
            <span title="Copy" class="copyPDFURLBtn" v-if="priorityData.CciMap.hasOwnProperty('Scorecard')" @click="copyPDFURLCopyToClipboard()"><v-icon name="copy"></v-icon></span>
			<span class="copiedPDFUrl" style="display:none;">Copied</span>
            <div v-if="isProfileChange" class="loader1">
            <div>
                <div class="lds-ripple">
                <div></div>
                <div></div>
                </div>
            </div>
            </div>
            <div class="RangeTableContent" ref="screenshotContainer">
                <table>
                    <thead>
                        <tr>
                            <th scope="col">CAPACITIES</th>
                            <th scope="col" colspan="2">Candidate<br>Score</th>
                            <th scope="col" colspan="2">
                                <u>Desired Range</u>
                                <br>Low
                            </th>
                            <th scope="col" colspan="2">
                                <u>Desired Range</u>
                                <br>High
                            </th>
                            <th scope="col" colspan="2">Assessment<br>Rating</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>Builder</td>
                            <td scope="row" colspan="2">{{priorityData.CciMap.Builder}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.BuilderLower ? selectedProfilePriorityData.BuilderLower : 0}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.BuilderUpper ? selectedProfilePriorityData.BuilderUpper : 36}}</td>
                            <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Builder, selectedProfilePriorityData.BuilderLower, selectedProfilePriorityData.BuilderUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                        </tr>
                        <tr>
                            <td>Merchant</td>
                            <td scope="row" colspan="2">{{priorityData.CciMap.Merchant}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.MerchantLower ? selectedProfilePriorityData.MerchantLower : 0}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.MerchantUpper ? selectedProfilePriorityData.MerchantUpper : 36}}</td>
                            <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Merchant, selectedProfilePriorityData.MerchantLower, selectedProfilePriorityData.MerchantUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                        </tr>
                        <tr>
                            <td>Innovator</td>
                            <td scope="row" colspan="2">{{priorityData.CciMap.Innovator}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.InnovatorLower ? selectedProfilePriorityData.InnovatorLower : 0}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.InnovatorUpper ? selectedProfilePriorityData.InnovatorUpper : 36}}</td>
                            <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Innovator, selectedProfilePriorityData.InnovatorLower, selectedProfilePriorityData.InnovatorUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                        </tr>
                        <tr>
                            <td>Banker</td>
                            <td scope="row" colspan="2">{{priorityData.CciMap.Banker}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.BankerLower ? selectedProfilePriorityData.BankerLower : 0}}</td>
                            <td scope="row" colspan="2">{{selectedProfilePriorityData.BankerUpper ? selectedProfilePriorityData.BankerUpper : 36}}</td>
                            <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Banker, selectedProfilePriorityData.BankerLower, selectedProfilePriorityData.BankerUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                        </tr>
                    </tbody>
                    <div class="typesTitle">TYPES</div>
                    <tbody>
                        <tr>
                            <td>Community</td>
                            <td colspan="2">{{priorityData.CciMap.Community}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.CommunityLower ? selectedProfilePriorityData.CommunityLower : 0}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.CommunityUpper ? selectedProfilePriorityData.CommunityUpper : 72}}</td>
                            <td class="lastChild" rowspan="2" colspan="2"><span :style="(rangeWithinTypes(priorityData.CciMap.Independent, selectedProfilePriorityData.IndependentLower, selectedProfilePriorityData.IndependentUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
                        </tr>
                        <tr class="border-class">
                            <td>Independent</td>
                            <td colspan="2">{{priorityData.CciMap.Independent}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.IndependentLower ? selectedProfilePriorityData.IndependentLower : 0}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.IndependentUpper ? selectedProfilePriorityData.IndependentUpper : 72}}</td>
                        </tr>
                        <tr>
                            <td>Intuitive</td>
                            <td colspan="2">{{priorityData.CciMap.Intuitive}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.IntuitiveLower ? selectedProfilePriorityData.IntuitiveLower : 0}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.IntuitiveUpper ? selectedProfilePriorityData.IntuitiveUpper : 72}}</td>
                            <td class="lastChild" rowspan="2" colspan="2"><span :style="(rangeWithinTypes(priorityData.CciMap.Cognitive, selectedProfilePriorityData.CognitiveLower, selectedProfilePriorityData. CognitiveUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
                        </tr>
                        <tr class="border-class">
                            <td>Cognitive</td>
                            <td colspan="2">{{priorityData.CciMap.Cognitive}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.CognitiveLower ? selectedProfilePriorityData.CognitiveLower : 0}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.CognitiveUpper ? selectedProfilePriorityData.CognitiveUpper : 72}}</td>
                        </tr>
                        <tr>
                            <td>Practical</td>
                            <td colspan="2">{{priorityData.CciMap.Practical}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.PracticalLower ? selectedProfilePriorityData.PracticalLower : 0}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.PracticalUpper ? selectedProfilePriorityData.PracticalUpper : 72}}</td>
                            <td rowspan="2" colspan="2" class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Creative, selectedProfilePriorityData.CreativeLower, selectedProfilePriorityData.CreativeUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
                        </tr>
                        <tr>
                            <td>Creative</td>
                            <td colspan="2">{{priorityData.CciMap.Creative}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.CreativeLower ? selectedProfilePriorityData.CreativeLower : 0}}</td>
                            <td colspan="2">{{selectedProfilePriorityData.CreativeUpper ? selectedProfilePriorityData.CreativeUpper : 72}}</td>
                        </tr>
                    </tbody>
                </table>
                <div class="hiringRecommendation">
                    <span class="lefttitle">Hiring Recommendation:</span>
                    <span v-if="priorityData.CciMap.Priority == 1" class="righttitle pr01">Recommended+</span>
                    <span v-if="priorityData.CciMap.Priority == 2" class="righttitle pr02">Hire with caution</span>
                    <span v-if="priorityData.CciMap.Priority == 3" class="righttitle pr03">Candidate May Struggle</span>
                </div>
                <div class="ratingKeySection">
                    <div class="ratingKey">Rating Key:</div>
                    <div class="ratingDiv">
                        <span class="color-circle ratingg"></span>
                        <span class="ratingTitle">Strong alignment to profile</span>
                        <span class="ratingPipe">|</span>
                    </div>
                    <div class="ratingDiv">
                        <span class="color-circle ratingy"></span>
                        <span class="ratingTitle">Area of concern</span>
                        <span class="ratingPipe">|</span>
                    </div>
                    <div class="ratingDiv">
                        <span class="color-circle ratingr"></span>
                        <span class="ratingTitle">Candidate may struggle</span>
                    </div>
                </div>
            </div>           
            <div class="assPDFSection">
                <div id="assessmentPDFHTML">
                    <div class="pdfLogo">
                        <img src="./../../../../../public/img/3P_LOGO_Reversed-big.png">
                    </div>
                    <div class="scorecardImg">
                        <img src="./../../../../../public/img/scorecard.png" />
                    </div>
                    <div class="assPDFBody">
                        <div class="pdftitle">HIRING RECOMMENDATION SCORECARD</div>
                        <div class="pdfsubtitle">
                            <div><span>Candidate Name:</span><b>{{ this.tempPros.First +' '+ this.tempPros.Last }}</b></div>
                            <div><span>Date:</span>{{pdfDate}}</div>
                            <div><span>Licensed:</span>{{manageLicensed}}</div>
                            <div><span>Enrolled in Course:</span>{{managePreLicensed === '' ? 'No' : managePreLicensed}}</div>
                        </div>  
                        <div class="RangeTableContent">
                            <table>
                                <thead>
                                    <tr>
                                        <th scope="col">CAPACITIES</th>
                                        <th scope="col" colspan="2">Candidate<br>Score</th>
                                        <th scope="col" colspan="2">
                                            <u>Desired Range</u>
                                            <br>Low
                                        </th>
                                        <th scope="col" colspan="2">
                                            <u>Desired Range</u>
                                            <br>High
                                        </th>
                                        <th scope="col" colspan="2">Assessment<br>Rating</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Builder</td>
                                        <td scope="row" colspan="2">{{priorityData.CciMap.Builder}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.BuilderLower ? selectedProfilePriorityData.BuilderLower : 0}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.BuilderUpper ? selectedProfilePriorityData.BuilderUpper : 36}}</td>
                                        <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Builder, selectedProfilePriorityData.BuilderLower, selectedProfilePriorityData.BuilderUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Merchant</td>
                                        <td scope="row" colspan="2">{{priorityData.CciMap.Merchant}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.MerchantLower ? selectedProfilePriorityData.MerchantLower : 0}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.MerchantUpper ? selectedProfilePriorityData.MerchantUpper : 36}}</td>
                                        <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Merchant, selectedProfilePriorityData.MerchantLower, selectedProfilePriorityData.MerchantUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Innovator</td>
                                        <td scope="row" colspan="2">{{priorityData.CciMap.Innovator}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.InnovatorLower ? selectedProfilePriorityData.InnovatorLower : 0}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.InnovatorUpper ? selectedProfilePriorityData.InnovatorUpper : 36}}</td>
                                        <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Innovator, selectedProfilePriorityData.InnovatorLower, selectedProfilePriorityData.InnovatorUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Banker</td>
                                        <td scope="row" colspan="2">{{priorityData.CciMap.Banker}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.BankerLower ? selectedProfilePriorityData.BankerLower : 0}}</td>
                                        <td scope="row" colspan="2">{{selectedProfilePriorityData.BankerUpper ? selectedProfilePriorityData.BankerUpper : 36}}</td>
                                        <td class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Banker, selectedProfilePriorityData.BankerLower, selectedProfilePriorityData.BankerUpper,yellowColorLogic=2,redColorLogic=3))" class="color-circle"></span></td>
                                    </tr>
                                </tbody>
                                <div class="typesTitle">TYPES</div>
                                <tbody>
                                    <tr>
                                        <td>Community</td>
                                        <td colspan="2">{{priorityData.CciMap.Community}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.CommunityLower ? selectedProfilePriorityData.CommunityLower : 0}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.CommunityUpper ? selectedProfilePriorityData.CommunityUpper : 72}}</td>
                                        <td class="lastChild" rowspan="2" colspan="2"><span :style="(rangeWithinTypes(priorityData.CciMap.Independent, selectedProfilePriorityData.IndependentLower, selectedProfilePriorityData.IndependentUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
                                    </tr>
                                    <tr class="border-class">
                                        <td>Independent</td>
                                        <td colspan="2">{{priorityData.CciMap.Independent}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.IndependentLower ? selectedProfilePriorityData.IndependentLower : 0}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.IndependentUpper ? selectedProfilePriorityData.IndependentUpper : 72}}</td>
                                    </tr>
                                    <tr>
                                        <td>Intuitive</td>
                                        <td colspan="2">{{priorityData.CciMap.Intuitive}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.IntuitiveLower ? selectedProfilePriorityData.IntuitiveLower : 0}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.IntuitiveUpper ? selectedProfilePriorityData.IntuitiveUpper : 72}}</td>
                                        <td class="lastChild" rowspan="2" colspan="2"><span :style="(rangeWithinTypes(priorityData.CciMap.Cognitive, selectedProfilePriorityData.CognitiveLower, selectedProfilePriorityData. CognitiveUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
                                    </tr>
                                    <tr class="border-class">
                                        <td>Cognitive</td>
                                        <td colspan="2">{{priorityData.CciMap.Cognitive}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.CognitiveLower ? selectedProfilePriorityData.CognitiveLower : 0}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.CognitiveUpper ? selectedProfilePriorityData.CognitiveUpper : 72}}</td>
                                    </tr>
                                    <tr>
                                        <td>Practical</td>
                                        <td colspan="2">{{priorityData.CciMap.Practical}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.PracticalLower ? selectedProfilePriorityData.PracticalLower : 0}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.PracticalUpper ? selectedProfilePriorityData.PracticalUpper : 72}}</td>
                                        <td rowspan="2" colspan="2" class="lastChild"><span :style="(rangeWithinTypes(priorityData.CciMap.Creative, selectedProfilePriorityData.CreativeLower, selectedProfilePriorityData.CreativeUpper,yellowColorLogic=5,redColorLogic=6))" class="color-circle"></span></td>
                                    </tr>
                                    <tr>
                                        <td>Creative</td>
                                        <td colspan="2">{{priorityData.CciMap.Creative}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.CreativeLower ? selectedProfilePriorityData.CreativeLower : 0}}</td>
                                        <td colspan="2">{{selectedProfilePriorityData.CreativeUpper ? selectedProfilePriorityData.CreativeUpper : 72}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div class="hiringRecommendation">
                                <span class="lefttitle">Hiring Recommendation:</span>
                                <span v-if="priorityData.CciMap.Priority == 1" class="righttitle pr01">Recommended+</span>
                                <span v-if="priorityData.CciMap.Priority == 2" class="righttitle pr02">Hire with caution</span>
                                <span v-if="priorityData.CciMap.Priority == 3" class="righttitle pr03">Candidate May Struggle</span>
                            </div>
                            <div class="ratingKeySection">
                                <div class="ratingKey">Rating Key:</div>
                                <div class="ratingDiv">
                                    <span class="color-circle ratingg"></span>
                                    <span class="ratingTitle">Strong alignment to profile</span>
                                    <span class="ratingPipe">|</span>
                                </div>
                                <div class="ratingDiv">
                                    <span class="color-circle ratingy"></span>
                                    <span class="ratingTitle">Area of concern</span>
                                    <span class="ratingPipe">|</span>
                                </div>
                                <div class="ratingDiv">
                                    <span class="color-circle ratingr"></span>
                                    <span class="ratingTitle">Candidate may struggle</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
		</div>

            <!--
            <b-card ref="screenshotContainer" class="priority-card">
                <div class="range-wrapper">
                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center greysection">
                        <span class="range-slider-label">Builder</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': builderLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Builder}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="36"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.BuilderLower ? defaultProfile.BuilderLower : 0"
                        :maxValue="defaultProfile.BuilderUpper"
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center whitesection">
                        <span class="range-slider-label">Merchant</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': merchentLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Merchant}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="36"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.MerchantLower ? defaultProfile.MerchantLower : 0"
                        :maxValue="defaultProfile.MerchantUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center greysection">
                        <span class="range-slider-label">Innovator</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': inovatorLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Innovator}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="36"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.InnovatorLower ? defaultProfile.InnovatorLower : 0"
                        :maxValue="defaultProfile.InnovatorUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center whitesection">
                        <span class="range-slider-label">Banker</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': bankerLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Banker}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="36"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.BankerLower ? defaultProfile.BankerLower : 0"
                        :maxValue="defaultProfile.BankerUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center greysection">
                        <span class="range-slider-label">Intuitive</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': intuitiveLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Intuitive}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="72"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.IntuitiveLower ? defaultProfile.IntuitiveLower : 0"
                        :maxValue="defaultProfile.IntuitiveUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center whitesection">
                        <span class="range-slider-label">Cognitive</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': cognitiveLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Cognitive}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="72"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.CognitiveLower ? defaultProfile.CognitiveLower : 0"
                        :maxValue="defaultProfile.CognitiveUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center greysection">
                        <span class="range-slider-label">Practical</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': practicalLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Practical}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="72"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.PracticalLower ? defaultProfile.PracticalLower : 0"
                        :maxValue="defaultProfile.PracticalUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center whitesection">
                        <span class="range-slider-label">Creative</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': creativeLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Creative}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="72"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.CreativeLower ? defaultProfile.CreativeLower : 0"
                        :maxValue="defaultProfile.CreativeUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center greysection">
                        <span class="range-slider-label">Independent</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': independentLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Independent}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="72"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.IndependentLower ? defaultProfile.IndependentLower : 0"
                        :maxValue="defaultProfile.IndependentUpper"
                        
                        />
                    </div>

                    <div class="range-slider-wrapper assessment-range-slider d-flex align-items-center whitesection">
                        <span class="range-slider-label">Community</span>
                        <span style="position:relative"><span class="range-slider-sign" :style="{'left': communityLeftPosition}"><span class="sign-hover-item">{{priorityData.CciMap.Community}}</span></span></span>
                        <MultiRangeSlider
                        :min="0"
                        :max="72"
                        :step="1"
                        :ruler="false"
                        :label="true"
                        :minValue="defaultProfile.CommunityLower ? defaultProfile.CommunityLower : 0"
                        :maxValue="defaultProfile.CommunityUpper"
                        
                        />
                    </div>
                </div>
            </b-card>
            -->

            <b-button v-if="EmailAssBtnOption" @click="emailAssessmentCanvas" variant="outline-primary mt-3 ml-3"><i>Email Assessment Result</i></b-button>
            <b-button v-if="PrepEmailAssBtnOption" variant="primary mt-3 ml-3" style="font-size: 13px;"><i>Preparing graphical chart, wait a moment...</i></b-button>
        </div>

        <div v-if="isShowEmail" class="p-3 coustom-email-priority">
            <EmailModal :emailData="emailData" />
        </div>

        <div style="display:none;" id="result1"  >
            <div>
                <p style="font-weight:600;color:#000;">Hello,</p>
                <p style="font-weight:600;color:#000;">Here are the CCI Assessment Results for {{priorityData.First}} {{priorityData.Last}}.</p>
                <p style="margin-bottom:0"><b>CONTACT INFORMATION:</b></p>
                <p style="margin-bottom:0"><b>Name: </b>{{priorityData.First}} {{priorityData.Last}}</p>
                <p style="margin-bottom:0"><b>Email: </b>{{priorityData.Email}}</p>
                <p style="margin-bottom:0"><b>Phone Number: </b>{{this.$parseNumber(priorityData.Number)}}</p>
                <p style="margin-bottom: 1rem;"><b>Postal Code: </b>{{priorityData.Zip}} </p>
                <p><b>CCI Scores</b></p>
                <p style="margin-bottom: 1rem;" v-if="priorityData.CciMap.hasOwnProperty('Scorecard')"><a style="color:#007bff;" target="blank" :href="priorityData.CciMap.Scorecard">Hiring Scorecard</a></p>
                <p style="margin-bottom:1rem;"><b>Priority Score: </b> {{priorityData.CciMap.Priority}}</p>
                <p style="margin-bottom: 1rem;"> <b>Licensed?:</b> {{manageLicensed}}</p>
                <p style="margin-bottom: 1rem;" v-if="(priorityData.hasOwnProperty('EnrolledCourse') && typeof priorityData.EnrolledCourse === 'boolean')"> <b>Enrolled in Course?:</b> {{managePreLicensed}}</p>
                <p style="margin-bottom:1rem;"><img :src="this.AssessmentResultsImg" width="100%" /></p>        
                <!--<table style="border: trasparent;width: 100% !important;margin-bottom:20px">
                    <tr>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Builder</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Merchant</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Innovator</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Banker</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Intuitive</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Cognitive</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Practical</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Creative</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Independent</th>
                        <th style="border: 0.2px solid #fff;background: #a9a6a6;font-size: 13px;padding-bottom: 10px;padding-top: 5px;text-align: center;">Community</th>
                    </tr>
                    <tbody>
                        <tr>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Builder}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Merchant}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Innovator}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Banker}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Intuitive}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Cognitive}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Practical}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Creative}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Independent}}</b></td>
                            <td style="border: 1px solid #fff;background: #d3d2d2;padding-bottom: 10px;padding-top: 5px;font-size: 16px;text-align: center;"><b>{{priorityData.CciMap.Community}}</b></td>
                        </tr>
                    </tbody>
                </table>-->
                <p> 
                    <b> {{priorityData.CciMap.SnapshotName}} Summary </b> <a target="blank" :href="snapshotDetails.Url" style="color:#007bff;cursor: pointer"><i>{{priorityData.CciMap.SnapshotName}} Profile</i> </a> 
                </p>
                <p>
                    <span v-html="snapshotDetails.Summary"></span>
                </p>
                <p> 
                    <b> {{priorityData.CciMap.SnapshotName}} Interview Questions </b>
                    
                    <span v-html="snapshotDetails.Questions"></span>
                </p>

                <p style="margin-bottom:5px">Learn more about <a href="https://thirdpool.com/assessment/CoreValues.html" target="_blank" style="color:#007bff;cursor: pointer">Core Capacities and Personality Types </a></p><p>Read ThirdPool's <a target="_blank" href=" https://thirdpool.com/assessment/Interviewing-Primer.pdf" style="color:#007bff;cursor: pointer">"Preparing for an Interview"</a> primer on conducting a successful interview. </p>

                <p style="margin-bottom:0">{{this.user.First}} {{this.user.Last}}</p>
                <p style="margin-bottom:0">{{this.user.Title}}</p>
                <p style="margin-bottom:0">{{this.$parseNumber(this.user.Twilio)}}</p>
                <p>{{this.user.SendGrid}} </p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
	import { mapState } from 'vuex'
    import copyToClipboard from 'copy-to-clipboard';
    // import MultiRangeSlider from "multi-range-slider-vue";
     import VueHtml2Canvas from 'vue-html2canvas';
	import { getAppSettings} from 'src/db';
    import EmailModal from "./EmailModal.vue";
     import axios from "axios";
    import moment from 'moment';
    Vue.use(VueHtml2Canvas);
	export default {
        components: {
            // MultiRangeSlider,
            EmailModal
        },
		name: "PriorityDetailModal",
		props: {
			error: String,
			priorityData:{},
            defaultProfile:{},
            emailData:{}
		},
		computed: {
            selectedProfilePriorityData() {
                return this.selectedProfile || this.defaultProfile;
            },
            filteredProspectsForProfiles() {
                return this.user.CciProfiles || [];
            },
            manageLicensed() {
                if(this.priorityData.Licensed == true) { return 'Yes'; } else { return 'No'; }
            },
            managePreLicensed() {
                if(this.priorityData.Licensed == false) {
                    if(this.priorityData.EnrolledCourse == true) { return 'Yes'; } else { return 'No'; }
                } else { return ''; }
            },
			...mapState('globals', ['activeProsp']),
			...mapState('firebase', ['prospects','user','mails']),
		},
        methods: {
            // RE-CALCULATE PDF AND URL
            async assessmentPDFProcess() {
                try {
                    const el = document.getElementById("assessmentPDFHTML");
                    const options = {
                        type: "dataURL",
                        useCORS: false,
                        imageSmoothingEnabled: false,
                    };
                    if (el) {
                        el.style.width = "1200px";
                        await new Promise(resolve => setTimeout(resolve, 1000));
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        const canvasWidth = 1200; 
                        const scaleFactor = canvasWidth / el.offsetWidth;
                        const canvasHeight = el.offsetHeight * scaleFactor;
                        canvas.width = canvasWidth;
                        canvas.height = canvasHeight;
                        await this.$html2canvas(el, {
                            ...options,
                            canvas: canvas,
                            canvasContext: ctx,
                            scale: scaleFactor
                        }).then(() => {
                            if (canvas instanceof HTMLCanvasElement) {
                                const dataURL = canvas.toDataURL();
                                let passData = {
                                    localArray: dataURL,
                                };
                                axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/assessmentUploadPDF", passData).then(response => {
                                    this.priorityData.CciMap.Scorecard=response.data.surl;
                                    this.isProfileChange=false;		
                                })
                            } else {
                                throw new Error("The canvas object is not a valid HTMLCanvasElement.");
                            }
                        });
                        el.style.width = "";
                    }
                } catch (error) {
                    //eslint-disable-next-line
                    console.error("Error finding HTML element:", error);
                }
			},
            // RE-CALCULATE PRIORITY LOGIC
			calculatePriorityLogic(data) {
				let val = 0;
				let pf,pfid;
                    let defaultProfile= this.selectedProfilePriorityData;
                    if (
                        (data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
                        (data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
                        (data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
                        (data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) &&
                        (data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
                        (data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
                        (data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
                        (data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
                        (data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
                        (data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper) 
                    ) {
                        val = 1;
                    } else if (
                        ((data.Builder >= defaultProfile.BuilderLower && data.Builder <= defaultProfile.BuilderUpper) &&
                        (data.Merchant >= defaultProfile.MerchantLower && data.Merchant <= defaultProfile.MerchantUpper) && 
                        (data.Innovator >= defaultProfile.InnovatorLower && data.Innovator <= defaultProfile.InnovatorUpper) && 
                        (data.Banker >= defaultProfile.BankerLower && data.Banker <= defaultProfile.BankerUpper) )||
                        ((data.Intuitive >= defaultProfile.IntuitiveLower && data.Intuitive <= defaultProfile.IntuitiveUpper) &&
                        (data.Cognitive >= defaultProfile.CognitiveLower && data.Cognitive <= defaultProfile.CognitiveUpper) && 
                        (data.Practical >= defaultProfile.PracticalLower && data.Practical <= defaultProfile.PracticalUpper) &&
                        (data.Creative >= defaultProfile.CreativeLower && data.Creative <= defaultProfile.CreativeUpper) &&
                        (data.Independent >= defaultProfile.IndependentLower && data.Independent <= defaultProfile.IndependentUpper) && 
                        (data.Community >= defaultProfile.CommunityLower && data.Community <= defaultProfile.CommunityUpper))
                    ) {
                        val = 2;
                    }else if (
                        ((data.Builder <= defaultProfile.BuilderLower || data.Builder >= defaultProfile.BuilderUpper) ||
                        (data.Merchant <= defaultProfile.MerchantLower || data.Merchant >= defaultProfile.MerchantUpper) ||
                        (data.Innovator <= defaultProfile.InnovatorLower || data.Innovator >= defaultProfile.InnovatorUpper) || 
                        (data.Banker <= defaultProfile.BankerLower || data.Banker >= defaultProfile.BankerUpper) ) &&
                        ((data.Intuitive <= defaultProfile.IntuitiveLower || data.Intuitive >= defaultProfile.IntuitiveUpper) ||
                        (data.Cognitive <= defaultProfile.CognitiveLower || data.Cognitive >= defaultProfile.CognitiveUpper) ||
                        (data.Practical <= defaultProfile.PracticalLower || data.Practical >= defaultProfile.PracticalUpper) ||
                        (data.Creative <= defaultProfile.CreativeLower || data.Creative >= defaultProfile.CreativeUpper) ||
                        (data.Independent <= defaultProfile.IndependentLower || data.Independent >= defaultProfile.IndependentUpper) || 
                        (data.Community <= defaultProfile.CommunityLower || data.Community <= defaultProfile.CommunityUpper))
                    ) {
                        val = 3;
                    }else{
                        val = 0;
                        pf = '';
                        pfid = '';
                    }
                    pf = defaultProfile.Name;
                    pfid = defaultProfile.ProfileId;
				return { val, pf, pfid };
			},
            // PROFILE DROP-DOWN CHANGES
            async onChangeProfile(){
                this.isProfileChange=true;
                this.selectedProfile=this.selectedProfile;
                this.recalculatePriority = this.calculatePriorityLogic(this.priorityData.CciMap);  
                this.priorityData.CciMap.Priority=this.recalculatePriority.val;
                await this.assessmentPDFProcess();  
            },
            // COPY PDF URL - CLIPBOARD
            copyPDFURLCopyToClipboard() {
                var copyText = document.getElementById("copyPDFURLID");
                var link = copyText.getAttribute("href");
				copyToClipboard(link);
				var editspan = document.getElementsByClassName("copiedPDFUrl")[0];
				if(editspan) {
					editspan.style.display = "block";
					setTimeout(() => {
						editspan.style.display = "none";
					}, 2000);
				}
			},
            async emailAssessmentCanvas() {
                
                this.EmailAssBtnOption = false;
                this.PrepEmailAssBtnOption = true;
                this.AssessmentResultsImg = '';
                
                const el = this.$refs.screenshotContainer;
                const options = {
                    type: "dataURL",
                    useCORS: true,
                    imageSmoothingEnabled: false
                };
                this.output = await this.$html2canvas(el, options);
                let passData = {
					localArray: this.output,
					prosID: this.activeProsp
				};
                await axios.post("https://us-central1-tatext-thirdpool.cloudfunctions.net/tatext/assessmentEmailChart", passData)
				.then(response => {
                    //eslint-disable-next-line
					console.log('response:', response);
					this.AssessmentResultsImg = response.data;
                    setTimeout(() => {
                        this.emailAssessment();
                    }, 2000);
                }).catch(err => {
					//eslint-disable-next-line
					console.log('err response', err);
				});
            },
			emailAssessment() {
                this.isShowEmail = true;
                let divHtml = document.getElementById("result1").innerHTML;
                this.emailData.message.Content = divHtml;
                this.emailData.Name = this.priorityData.First +' ' + this.priorityData.Last;
            },
            // RANGE TABLE
            rangeWithinTypes(value, minValue, maxValue, yellowColorLogic, redColorLogic) {
                var colorCode;
                if (value >= minValue && value <= maxValue) {
                    colorCode = 'background-color: #2fca2f'; // GREEN
                } else if ((value >= minValue - yellowColorLogic && value <= minValue) || (value >= maxValue && value <= maxValue + yellowColorLogic)) {
                    colorCode = 'background-color: #dcdc09'; // YELLOW
                } else if ((value >= minValue - redColorLogic && value <= minValue) || (value >= maxValue && value <= maxValue + redColorLogic)) {
                    colorCode = 'background-color: #fd4c4c'; // RED
                } else {
                    colorCode = 'background-color: #fd4c4c'; // RED
                }
                return colorCode;
            },
        },
		data() {
            return {
                snapshotDetails:{},
                isShowEmail:false,
                selectedProfile:this.defaultProfile,
                builderLeftPosition:'13px',
                merchentLeftPosition:'13px',
                inovatorLeftPosition:'13px',
                bankerLeftPosition:'13px',

                intuitiveLeftPosition:'6.5px',
                cognitiveLeftPosition:'6.5px',
                practicalLeftPosition:'6.5px',
                creativeLeftPosition:'6.5px',
                independentLeftPosition:'6.5px',
                communityLeftPosition:'6.5px',
                prioritySubmittedDate: '',

                AssessmentResultsImg: '',
                PrepEmailAssBtnOption: false,
                EmailAssBtnOption: true,
                displayLicensed: '',
                displayPreLicensed: '',
                recalculatePriority:0,
                isProfileChange:false,
                tempPros:{},
                pdfDate:'',
                isProfileDisabled:false
            }
        },
		async created() {
            //eslint-disable-next-line
            // console.log(this.priorityData);
            
            var priorityDataDT = this.priorityData.CciMap.DateSubmitted;
            if(priorityDataDT) {
                let InterviewDateTimezoneWise;
                if(this.user.hasOwnProperty('TimeZone')) {
                    let getUserTimezone = this.user.TimeZone;
                    var datea = new Date(priorityDataDT);
                    var Pacific, Mountain, Central, Eastern;
                    if(getUserTimezone == 0) {
                        Pacific = datea.toLocaleString('en-US', { timeZone: 'Canada/Pacific', });
                        InterviewDateTimezoneWise = moment(Pacific).valueOf();
                    }
                    if(getUserTimezone == 1) {
                        Mountain = datea.toLocaleString('en-US', { timeZone: 'Canada/Mountain', });
                        InterviewDateTimezoneWise = moment(Mountain).valueOf();
                    }
                    if(getUserTimezone == 2) {
                        Central = datea.toLocaleString('en-US', { timeZone: 'Canada/Central', });
                        InterviewDateTimezoneWise = moment(Central).valueOf();
                    }
                    if(getUserTimezone == 3) {
                        Eastern = datea.toLocaleString('en-US', { timeZone: 'Canada/Eastern', });
                        InterviewDateTimezoneWise = moment(Eastern).valueOf();
                    }
                }
                this.prioritySubmittedDate = moment(InterviewDateTimezoneWise).format('MM/DD/YYYY hh:m A');
            } else {
                this.prioritySubmittedDate = '';
            }
            
            this.builderLeftPosition = (this.priorityData.CciMap.Builder*16) - 4 +'px';
            this.merchentLeftPosition = (this.priorityData.CciMap.Merchant*16) - 4 +'px';
            this.inovatorLeftPosition = (this.priorityData.CciMap.Innovator*16) - 4 +'px';
            this.bankerLeftPosition = (this.priorityData.CciMap.Banker*16) - 4 +'px';

            this.intuitiveLeftPosition = (this.priorityData.CciMap.Intuitive*8) - 2 +'px';
            this.cognitiveLeftPosition = (this.priorityData.CciMap.Cognitive*8) - 2 +'px';
            this.practicalLeftPosition = (this.priorityData.CciMap.Practical*8) - 2 +'px';
            this.creativeLeftPosition = (this.priorityData.CciMap.Creative*8) - 2 +'px';
            this.independentLeftPosition = (this.priorityData.CciMap.Independent*8) - 2 +'px';
            this.communityLeftPosition = (this.priorityData.CciMap.Community*8) - 2 +'px';
            getAppSettings({
				sid:'1izpGSmYBlUGDSdKIRxa'
			})
			.then((res) => {
                let spa = res.data.Snapshots;
                let f =  spa.find(p => p.Name == this.priorityData.CciMap.SnapshotName);
                if (f) {
                    this.snapshotDetails = f;
                }
			})
			.catch(err => alert(`Failure In Getting AppSettings : ${err}`));
            this.tempPros=this.prospects.find(item=>item.id == this.activeProsp);
            if(this.tempPros.DateCreated <= 1701734460000){this.isProfileDisabled=true}
            this.pdfDate = moment(this.tempPros.DateCreated).format('MMMM DD, YYYY');
		}
	}
</script>

<style scoped>
    .assessment-range-slider {
        max-width: 100%;
        margin: auto;
    }
    .assessment-range-slider .range-slider-label {
        min-width: 150px;
        max-width: 200px;
        text-align: center;
        font-weight: 600;font-size: 13px;margin-top: -10px;
    }
    .assessment-range-slider .multi-range-slider {
        width: calc(100% - 150px);padding: 13px 10px !important;
    }
    .card.priority-card {
        border: none;
        background: rgb(246 248 253 / 40%);
    }
    .priority-card .card-body {
        padding: 20px 5px;
        border: none;
    }
    .coustom-email-priority{
        overflow: auto;
        height: 500px;
    }
    .range-slider-sign{
        position: absolute;
        bottom: -3px;
        cursor: pointer;
        z-index: 3;
        background-color: #A6A6A6;
        color: #fff;
        width: 20px;
        height: 20px;
        border-radius: 20px;
        -webkit-border-radius: 20px;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        text-align: center;
    }
    /* .range-slider-sign:after {
        position: absolute;
        content: '';
        left: 0;
        border-radius: 11px;
        top: 13.5px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top-width: 14px;
        border-top-style: solid;
        border-top-color: #003e80;
    } */
    .sign-hover-item {
        position: relative;
        color: #ffffff;
        z-index: 9999999;
        font-size: 11px;
        top: -3px;
    }
    .AssessmentResultsImg{
        width: 100%;
    }
    .copyPDFURLBtn{
        position: absolute;
        top: 115px;
        left: 140px;
        color: #b9b9b9;
        cursor: pointer;
    }
    .copiedPDFUrl{
        position: absolute;
        top: 115px;
        left: 135px;
        background: #86d386;
        border-radius: 2px;
        padding: 2px 5px;
        color: white;
    }
    .assPDFSection{
        opacity: 0;
        height: 1px;
        overflow-y: scroll;
    }
    .assPDFSection .pdfLogo{
        background: #1e5577; 
        color: #fff; 
        padding: 10px 20px
    }
    .assPDFSection .pdfLogo img{
        width:24%; 
        margin: 10px 0px 5px 0px;
    }
    .assPDFSection .scorecardImg img{
        width: 10%;
        float: right; 
        margin-top: -40px; 
        margin-right: 8%;
    }
    
    .assPDFBody {
        background: #fff;
        padding: 10px 26px; 
        font-size: 18px;
    }
    .assPDFBody .RangeTableContent .hiringRecommendation {
        font-size: 20px;
        margin-top: 35px;
        margin-bottom: 20px;
    }
    .assPDFBody .pdftitle {
        color: #1e5577;
        font-weight: 700;
        font-size: 20px;
        padding: 10px 0px;
    }

    .assPDFBody .pdfsubtitle span {
        width: 22%;
        display: inline-block;
    }
    .assPDFBody .RangeTableContent th:first-child, 
    .assPDFBody .RangeTableContent .typesTitle {
        font-size: 18px;
    }
    .assPDFBody .RangeTableContent .ratingKeySection{
        padding: 12px 0px
    }
    .assPDFBody .pdfsubtitle {
        margin: 15px 0px 20px 0px;
    }

    .assPDFBody .RangeTableContent {
        margin: 0px;
    }

    .assPDFBody .RangeTableContent .ratingKeySection .ratingPipe {
        padding: 0px 30px;
    }
    .assPDFBody .RangeTableContent .ratingKeySection .ratingKey{
        padding-right: 65px;
    }
    .assPDFBody .RangeTableContent .ratingKeySection .ratingDiv {
        display: flex;
        align-items: center;
    }
    .RangeTableContent .hiringRecommendation .righttitle {
        width: 30%;
    }
    .assPDFBody .RangeTableContent .ratingKeySection{
        position: relative;
        display: flex;
        margin-top: 10px;
        align-items: center;
    }
    .assPDFBody .RangeTableContent .ratingKeySection .ratingTitle {
        margin-left: 40px;
    }
    .contact-infor-table .assPDFBody table th[data-v-cc35de26], td{
        border-left: none;
    }
</style>